

const IconViewCV = ({ props }) => {
    return(    
    <svg width={22} height={22} fill="none" {...props}>
    <path
        d="M21.73 20.438l-5.288-5.29a9.238 9.238 0 002.1-5.877A9.271 9.271 0 000 9.271a9.271 9.271 0 009.272 9.272 9.223 9.223 0 005.873-2.097l5.29 5.285a.916.916 0 101.297-1.293zm-12.459-3.74c-4.099 0-7.43-3.332-7.43-7.427 0-4.094 3.331-7.43 7.43-7.43 4.095 0 7.431 3.336 7.431 7.43 0 4.095-3.336 7.427-7.43 7.427z"
        fill="#fff"
    />
    </svg>
    )
}

export default IconViewCV